import React, {useState, useEffect} from 'react';
import axios from 'axios';
import axiosUrl from '../../axios/url';
import PropTypes from 'prop-types';

import TagAddModal from './modal/TagAddModal';
import TagEditModal from './modal/TagEditModal';
import LowTagAddModal from './modal/LowTagAddModal';
import LowTagEditModal from './modal/LowTagEditModal';
import TagListHeader from './TagListHeader';


export default function TagList(param) {
    var curUrl = window.location.href;
    var result = '';
    if( curUrl.indexOf('tag') > -1)  result  = 'TAG';
    else  result = 'SCHEDULE';
    
    

    async function getRepresentiveList(projectId){
        await axios.get(axiosUrl.representives_list+"/"+projectId+"/representives?page=-1&sort=id&order=asc")
        .then( response => {
            // old value, new value를 비교하여 변화가 있을 때만, rendering함. 이 로직을 빼면 무한 렌더링에 빠짐.
            if(JSON.stringify(tagList) !== JSON.stringify(response.data)) { 
                setTagList(response.data);
                setfilterList(response.data);
                console.log("represent list success");
            }
        })
        .catch(function (e) {
                console.error('[MEDIEX_CMS_2019_ERROR] Project.getRepresentiveList - ' + e);
                console.error('[MEDIEX_CMS_2019_ERROR] axiosUrl - ' + axiosUrl.representives_list);
        });

    }

    const [projectId, setProjectId] = useState("-1");
    const [tagList, setTagList] = useState([]);
    const [filterList, setfilterList] = useState(tagList);
    const [selectLowTag, setSelectLowTag] = useState("");
    const [selectTag, setSelectTag] = useState("");
    const [showEditBtn, setShowEditBtn] = React.useState(false);
    
    useEffect(() => {
    }, [tagList]);

    function selectedLowTag(lowTag, representives) {
        setSelectLowTag(lowTag);
        setSelectTag(representives);
    }

    function selectedTag(representives) {
        setSelectTag(representives);
    }

    // 스케줄 태그 선택 모달에서 태그 선택
    function checkBoxTag(selectTag) {
        param.callbackCheckTag(selectTag);

    }

    function onMouseOverProjectList(){
        if(!showEditBtn) setShowEditBtn(true);
    }

    function onMouseLeaveProjectList(){
        if(showEditBtn) setShowEditBtn(false);
    }

    function callbackRepresentiveClose() {
        getRepresentiveList(projectId);
    }

    function callbackProjectId(projectId) {
        setProjectId(projectId);
        getRepresentiveList(projectId);
        if(result === "TAG") {
            param.callbackProjectId(projectId);
        }
    }

    function callbackFilterList(list) {
        setfilterList(list);
    }

    React.useEffect(() => {
        if(param.projectId !== '') {
            setProjectId(param.projectId);
            getRepresentiveList(param.projectId);
        }
    }, [param.projectId])

    return(
        <div className="card-body">  
            <TagListHeader projectId={param.projectId} tagList={tagList} callbackProjectId={callbackProjectId} callbackFilterList={callbackFilterList}/>
            <div className="mt-2 col-12 overflow-auto pb-3 height-max-560">
                <ul  className="list-group" id="accordionTag">
                    {filterList.map((representives, i) => (
                        <li key={i}  className={"list-group-item  tag-bg-color"+(i%2)}>
                            <div id={"heading"+i} className="mb-2">
                                <h1 className="mb-0 ">
                                    <a className="tag-name"  data-toggle="collapse" data-target={"#collapse"+i} aria-expanded="false" aria-controls={"collapse"+i}>
                                        {representives.name}
                                    </a>
                                
                                    {
                                        result === 'SCHEDULE' && <div className="form-group float-right">
                                                                    <div className="form-check">
                                                                        <a className="heifht-38" type="checkbox" onClick={() => checkBoxTag(representives)} data-dismiss="modal">
                                                                            <i className="fas fa-check"></i>
                                                                        </a>
                                                                    </div>
                                                                </div>
                                    }
                                    {
                                        result === 'TAG' &&  <a data-toggle="modal" data-target="#TagEditModal" onClick={() => selectedTag(representives)}><i className="fas fa-edit text-danger tag-name ml-2" /></a>
                                                        
                                    }
                                </h1>
                            </div>

                            <div id={"collapse"+i}  className="collapse mt-4 " aria-labelledby={"heading"+i} data-parent="#accordionTag">
                                {/*여기부터 하위태그 화면 시작 */}
                                <div  className="col-12 ml-3">
                                    {
                                        representives.tags.map((lowtag, j) => 
                                        <div  className="post" key={j}>
                                            <h6>
                                                <i className="fas fa-tags mr-2">
                                                    <p  className="nav-link d-inline lowtag-name" onMouseOver={onMouseOverProjectList}  onMouseLeave={onMouseLeaveProjectList} >
                                                        {lowtag.name}
                                                        {showEditBtn && <a data-toggle="modal" data-target="#lowTagEditModal" onClick={() => selectedLowTag(lowtag, representives)} ><i className="fas fa-edit ml-2 text-danger"></i></a>}
                                                    </p>
                                                </i>
                                            </h6>
                                            <p className="">
                                                {lowtag.description}
                                            </p>
                                        </div>
                                    )}   
                                    {
                                        result === 'SCHEDULE' && <div></div>
                                    }
                                    {
                                        result === 'TAG' && <a className="float-right text-primary" data-toggle="modal" data-target="#lowTagAddModal" onClick={() => selectedTag(representives)} ><i className="fas fa-plus "></i> 하위태그 추가 </a>
                                    }
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>

            {/* // 태그 */}
            <TagAddModal projectId={projectId} representiveCheck={param.representiveCheck} callbackRepresentiveClose={callbackRepresentiveClose}></TagAddModal>
            <TagEditModal projectId={projectId} name={selectTag.name} id={selectTag.id} callbackRepresentiveClose={callbackRepresentiveClose}></TagEditModal>
            <LowTagAddModal representiveId={selectTag.id} callbackRepresentiveClose={callbackRepresentiveClose}></LowTagAddModal>
            <LowTagEditModal name={selectLowTag.name} description={selectLowTag.description} representiveId={selectTag.id} id={selectLowTag.id} callbackRepresentiveClose={callbackRepresentiveClose}></LowTagEditModal>
        </div>
    );
}

LowTagEditModal.propTypes = {
    filterDataList: PropTypes.array,
    representiveCheck: PropTypes.bool,
    callbackTagList: PropTypes.array
  };